/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const MoveLeft = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M6 8L2 12L6 16" }],
    ["path", { d: "M2 12H22" }]
  ]
];

export { MoveLeft as default };
//# sourceMappingURL=move-left.js.map
